import { useRef } from "react";
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import SinglePage from "../SinglePage/SinglePage";
import { Container } from "./styles";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import TopicIntro from "../../base/Topic/TopicIntro";
import CustomTimeLine from "./CustomTimeLine/CustomTimeLine";

const History = () => {
    const topicIntroRef = useRef<HTMLDivElement>(null);

    const scrollToTopicIntro = () => {
        if (topicIntroRef.current) {
            smoothScrollTo(topicIntroRef.current, 2000);
        }
    };
    return (<SinglePage
        title='Geschichte'
        heroBanner={
            <HeroBanner
                imageSource={require('../../../assets/images/History/spookyVillageWithChurch.png')}
                headline="DIE GESCHICHTE."
                text="Lerne die Sage zur Entstehung der Eckenmoorhexen Sulgen kennen."
                onNextSection={scrollToTopicIntro}
            />
        }
        topic={
            <div ref={topicIntroRef}>
                <TopicIntro
                    headline="DIE GESCHICHTE."
                    introductionText="Einst lebte der Schweinezüchter Karl auf den Höhen Schrambergs, geschätzt in Sulgen und Sulgau. Doch eine unheimliche Nacht im Eckenwald veränderte alles. Aus dem Vorfall entstand eine Sage über Rache, Hexen und das düstere Moor. Bis heute treiben die Eckenmoorhexen zur Fasnet ihr geheimnisvolles Unwesen und erinnern an ein dunkles Geheimnis, das die Menschen nicht loslässt."
                />
            </div>
        }
        content={
            <>
                <Container>
                    <CustomTimeLine />
                </Container>
            </>
        }
    >
    </SinglePage>
    );
}

export default History;